module.exports = __webpack_public_path__ + "img/ilus-tc.0f8c9e5f.svg";